import { Injectable } from '@angular/core';
import { BackendApiType, ENTITY_TYPES, IEntityConfig } from '@app/shared/types';
import { BaseService } from '../base';

const entityType: ENTITY_TYPES = ENTITY_TYPES.CURRENCY_SCHEME;
const config: IEntityConfig = {
  backendApiType: BackendApiType.DM,
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  apiEndpoint: entityType,
  uiRoute: entityType,
  customEntityRoute: {
    list: 'master',
  },
  buttons: {},
};

@Injectable()
export class CurrencySchemeService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
}
